var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimpleStepsIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5043_5215",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 75,
    height: 75
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5043_5215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.75 62.5C16.1458 62.5 13.9323 61.5885 12.1094 59.7656C10.2865 57.9427 9.375 55.7292 9.375 53.125H3.125V18.75C3.125 17.0312 3.73698 15.5599 4.96094 14.3359C6.1849 13.112 7.65625 12.5 9.375 12.5H53.125V25H62.5L71.875 37.5V53.125H65.625C65.625 55.7292 64.7135 57.9427 62.8906 59.7656C61.0677 61.5885 58.8542 62.5 56.25 62.5C53.6458 62.5 51.4323 61.5885 49.6094 59.7656C47.7865 57.9427 46.875 55.7292 46.875 53.125H28.125C28.125 55.7292 27.2135 57.9427 25.3906 59.7656C23.5677 61.5885 21.3542 62.5 18.75 62.5ZM18.75 56.25C19.6354 56.25 20.3776 55.9505 20.9766 55.3516C21.5755 54.7526 21.875 54.0104 21.875 53.125C21.875 52.2396 21.5755 51.4974 20.9766 50.8984C20.3776 50.2995 19.6354 50 18.75 50C17.8646 50 17.1224 50.2995 16.5234 50.8984C15.9245 51.4974 15.625 52.2396 15.625 53.125C15.625 54.0104 15.9245 54.7526 16.5234 55.3516C17.1224 55.9505 17.8646 56.25 18.75 56.25ZM56.25 56.25C57.1354 56.25 57.8776 55.9505 58.4766 55.3516C59.0755 54.7526 59.375 54.0104 59.375 53.125C59.375 52.2396 59.0755 51.4974 58.4766 50.8984C57.8776 50.2995 57.1354 50 56.25 50C55.3646 50 54.6224 50.2995 54.0234 50.8984C53.4245 51.4974 53.125 52.2396 53.125 53.125C53.125 54.0104 53.4245 54.7526 54.0234 55.3516C54.6224 55.9505 55.3646 56.25 56.25 56.25ZM53.125 40.625H66.4062L59.375 31.25H53.125V40.625Z",
    fill: "#0097C5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimpleStepsIcon4);
export default __webpack_public_path__ + "static/media/SimpleStepsIcon4.a115f3fa658122654bd526362abcb1b2.svg";
export { ForwardRef as ReactComponent };